import "../carousel-buttons.scss"
import IconPrev from "../../../../../../components/icons/icon-prev/icon-prev";

interface ISlidePrevButton {
    swiper: any
}

const SlidePrevButton: React.FC<ISlidePrevButton> = ({swiper}) => {
    return (
        <button className="carousel-prev-button" onClick={() => swiper.slidePrev()}>
            <div className="icon-carousel">
                <IconPrev color={'var(--color-neutral-1-white)'}/>
            </div>
        </button>
    );
}

export default SlidePrevButton;